var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "container signin p-verify-photo" },
    [
      _c("div", { staticClass: "m-left" }, [
        _vm.signInType.phoneSignIn === 0
          ? _c(
              "div",
              {
                staticClass: "m-left__qrcode flex-column",
                attrs: { id: _vm.operationGuideListId[1] }
              },
              [
                _c("div", { staticClass: "flex-row m-qrcode__operation-row" }, [
                  _c("div", { staticClass: "flex-row m-operation__left" }, [
                    _c("div", { staticClass: "m-title" }, [
                      _vm._v(_vm._s(_vm.signType.signTypeName) + "码")
                    ]),
                    _c("i", {
                      staticClass: "el-icon-zoom-out m-operation__item",
                      on: { click: _vm.reduceQrCode }
                    }),
                    _c("i", {
                      staticClass: "el-icon-zoom-in m-operation__item",
                      on: { click: _vm.magnifyQrCode }
                    })
                  ]),
                  _c("div", { staticClass: "m-operation__right" }, [
                    _c("i", {
                      staticClass: "el-icon-circle-close m-operation__item",
                      on: {
                        click: function($event) {
                          return _vm.handleSignInType("phone")
                        }
                      }
                    })
                  ])
                ]),
                _c("QrCodeLogo", {
                  ref: "qrCodeLogoBox1",
                  attrs: {
                    content: _vm.qrCodeContent,
                    qrCodeWidth: _vm.opts.width,
                    qrCodeHeight: _vm.opts.width,
                    logoUrl: _vm.logoImg,
                    opts: _vm.opts
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "sign-record-wrap flex-row",
            attrs: { id: _vm.recordGuideId }
          },
          [
            _vm.isOpenSignRecord
              ? _c("div", { staticClass: "sign-record-list" }, [
                  _c("div", { staticClass: "m-sign-record__title" }, [
                    _vm._v(" " + _vm._s(_vm.signType.signTypeName) + "记录"),
                    _vm.signInLogList.list.length > 0
                      ? _c("span", [
                          _vm._v(
                            "（已" +
                              _vm._s(_vm.signType.signTypeName) +
                              " " +
                              _vm._s(_vm.getRightSignCount) +
                              "人）"
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm.signInLogList.list.length === 0
                    ? _c("div", { staticClass: "sign-in-box-no-data" }, [
                        _vm._v(
                          "暂时还没有人" + _vm._s(_vm.signType.signTypeName)
                        )
                      ])
                    : _c(
                        "div",
                        { staticClass: "m-record-list" },
                        _vm._l(_vm.signInLogList.list, function(item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "m-record-list__item" },
                            [
                              _c(
                                "div",
                                { staticClass: "m-item__name-source flex-row" },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content: _vm.formatterRecordRealNameAndIdentity(
                                          item
                                        ),
                                        placement: "top-start"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "m-item__name" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatterRecordRealNameAndIdentity(
                                                  item
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "m-item__sign-source" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("signSourceFilter")(
                                              item.signSource
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm.signType.signType === 2
                                ? _c("div", { staticClass: "m-item__time" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("timestampFilter")(
                                            item.endTime
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                : _vm.signType.signType === 1
                                ? _c("div", { staticClass: "m-item__time" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("timestampFilter")(
                                            item.validateTime
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                : _c("div", { staticClass: "m-item__time" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("timestampFilter")(
                                          item.startTime
                                        )
                                      )
                                    )
                                  ])
                            ]
                          )
                        }),
                        0
                      )
                ])
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "m-record-list__open-close",
                class: _vm.isOpenSignRecord
                  ? "m-record-list__open"
                  : "m-record-list__close",
                on: {
                  click: function($event) {
                    _vm.isOpenSignRecord = !_vm.isOpenSignRecord
                  }
                }
              },
              [
                !_vm.isOpenSignRecord
                  ? _c("i", { staticClass: "el-icon-arrow-right" })
                  : _c("i", { staticClass: "el-icon-arrow-left" })
              ]
            )
          ]
        )
      ]),
      _c("div", { staticClass: "m-right" }, [
        _c("div", { staticClass: "train-plan-info" }, [
          _c("div", { staticClass: "info-wrap" }, [
            _c("div", { staticClass: "m-info__left flex-column" }, [
              _c("div", { staticClass: "m-plan-name" }, [
                _vm._v(_vm._s(_vm.planData.planName || "计划名称错误"))
              ]),
              _c("div", { staticClass: "m-left__row flex-row" }, [
                _c("div", { staticClass: "m-row__item" }, [
                  _vm._v(
                    "所属组织：" +
                      _vm._s(
                        _vm.planData.planDto
                          ? _vm.planData.planDto.orgName
                          : "组织读取错误"
                      )
                  )
                ]),
                _c("div", { staticClass: "m-row__item" }, [
                  _vm._v(
                    " 培训进度：已完成" +
                      _vm._s(
                        _vm.planData.planDto
                          ? _vm.planData.planDto.studyFinishCount || 0
                          : 0
                      ) +
                      "人， 剩余" +
                      _vm._s(
                        _vm.planData.planDto
                          ? _vm.planData.planDto.restCount || 0
                          : 0
                      ) +
                      "人 "
                  )
                ]),
                _c("div", { staticClass: "m-row__item" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.isOfflineMeeting ? "参会人员：" : "参加人员："
                      ) +
                      _vm._s(
                        _vm.planData.planDto
                          ? _vm.planData.planDto.userCount
                          : 0
                      ) +
                      "人 "
                  )
                ])
              ]),
              _c("div", { staticClass: "m-left__row flex-row" }, [
                _c("div", { staticClass: "m-row__item" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.isOfflineMeeting ? "会议周期：" : "计划周期："
                      ) +
                      _vm._s(
                        _vm._f("timeFormatFilter")(
                          _vm.planData.planDto
                            ? _vm.planData.planDto.startTime
                            : "时间读取错误"
                        )
                      ) +
                      " 至 " +
                      _vm._s(
                        _vm._f("timeFormatFilter")(
                          _vm.planData.planDto
                            ? _vm.planData.planDto.endTime
                            : "时间读取错误"
                        )
                      ) +
                      " "
                  )
                ]),
                _c("div", { staticClass: "m-row__item" }, [
                  _vm._v("培训类别：" + _vm._s(_vm.getPlanSubjectName()))
                ]),
                _c("div", { staticClass: "m-row__item" }, [
                  _vm._v(
                    _vm._s(_vm.isOfflineMeeting ? "会议地点：" : "培训教室：") +
                      " " +
                      _vm._s(_vm.planData.classroomName || "无可用教室")
                  )
                ])
              ]),
              _c(
                "div",
                { staticClass: "m-left__row flex-row" },
                _vm._l(_vm.planData.offlinePlanLeaderDtoList, function(
                  item,
                  index
                ) {
                  return _c("div", { key: index, staticClass: "m-row__item" }, [
                    _vm._v(
                      " " +
                        _vm._s(item.leaderName) +
                        "： " +
                        _vm._s(item.realName || `无${item.leaderName}`) +
                        " "
                    )
                  ])
                }),
                0
              ),
              _vm.isOfflineMeeting
                ? _c(
                    "div",
                    { staticClass: "m-left__row flex-row meeting-info-cell" },
                    [
                      _c("label", [_vm._v("会议简介：")]),
                      _vm.planData.planDto &&
                      _vm.planData.planDto.introduction &&
                      _vm.planData.planDto.introduction.length > 10
                        ? _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.planData.planDto.introduction,
                                "popper-class": "common-tip-popper"
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      (_vm.planData.planDto &&
                                        _vm.planData.planDto.introduction) ||
                                        "暂无会议简介"
                                    )
                                )
                              ])
                            ]
                          )
                        : _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  (_vm.planData.planDto &&
                                    _vm.planData.planDto.introduction) ||
                                    "暂无会议简介"
                                )
                            )
                          ])
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _c("div", {
              staticClass: "m-line",
              class:
                _vm.planData.offlinePlanLeaderDtoList &&
                _vm.planData.offlinePlanLeaderDtoList.length > 0
                  ? ""
                  : "m-line__min"
            }),
            _vm.signType.signType === 0
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.nextLoading,
                        expression: "nextLoading"
                      }
                    ],
                    staticClass: "m-info__right flex-row",
                    attrs: { id: "step210" },
                    on: { click: _vm.toTrain }
                  },
                  [
                    _c("img", {
                      staticClass: "button-icon",
                      attrs: {
                        src: require("../../assets/img/sigin_in_play_icon.png")
                      }
                    }),
                    _c("span", { staticClass: "button-title" }, [
                      _vm._v(
                        _vm._s(_vm.isOfflineMeeting ? "开始会议" : "开始上课")
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm.signType.signType === 1 || _vm.signType.signType === 2
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.nextLoading,
                        expression: "nextLoading"
                      }
                    ],
                    staticClass: "m-info__right flex-row",
                    attrs: { id: "step220" },
                    on: { click: _vm.toContinueTrain }
                  },
                  [
                    _c("img", {
                      staticClass: "button-icon",
                      attrs: {
                        src: require("../../assets/img/sigin_in_play_icon.png")
                      }
                    }),
                    _c("span", { staticClass: "button-title" }, [
                      _vm._v(
                        _vm._s(_vm.isOfflineMeeting ? "继续会议" : "继续上课") +
                          " "
                      )
                    ])
                  ]
                )
              : _vm._e()
          ])
        ]),
        _c("div", { staticClass: "m-sign-wrap" }, [
          _c("div", { staticClass: "flex-row m-sign__user-and-verify" }, [
            _c("div", { staticClass: "m-user-and-verify__left flex-column" }, [
              _c(
                "div",
                { staticClass: "m-wait-sign-list" },
                [
                  _c(
                    "div",
                    { attrs: { id: _vm.operationGuideListId[0] } },
                    [
                      _c(
                        "div",
                        { staticClass: "m-sign-top__left flex-row" },
                        [
                          _c("div", { staticClass: "m-left__label" }, [
                            _vm._v("综合查询")
                          ]),
                          _c("el-input", {
                            attrs: {
                              type: "text",
                              size: "medium",
                              clearable: "",
                              placeholder: "请输入姓名/身份证号"
                            },
                            model: {
                              value: _vm.studentListParams.searchVal,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.studentListParams,
                                  "searchVal",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "studentListParams.searchVal"
                            }
                          }),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "medium", type: "primary" },
                              on: { click: _vm.studentSearch }
                            },
                            [_vm._v("查询")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex-row m-list__title-count" },
                        [
                          _vm._v(" 人员列表 "),
                          _c("div", { staticClass: "m-count__value" }, [
                            _vm._v(
                              " 待" + _vm._s(_vm.signType.signTypeName) + "人员"
                            ),
                            _c("span", { staticClass: "red-text" }, [
                              _vm._v(
                                _vm._s(_vm.staticObject.waitSignCount) + "人"
                              )
                            ])
                          ])
                        ]
                      ),
                      _c(
                        "el-table",
                        {
                          attrs: {
                            "max-height": "519",
                            stripe: "",
                            data: _vm.tableData
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "姓名", width: "100" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "span",
                                      { attrs: { title: scope.row.cardNo } },
                                      [
                                        _vm._v(
                                          " " + _vm._s(scope.row.realName) + " "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "cardNo", label: "身份证号" }
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "identityName", label: "身份" }
                          }),
                          _c("el-table-column", {
                            attrs: { label: "操作", width: "70" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "table-btn-sign-in-text",
                                        on: {
                                          click: function($event) {
                                            return _vm.signInStart(
                                              scope.row,
                                              $event
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.signUserInfo.signInTableText
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("el-pagination", {
                    attrs: {
                      layout: "sizes,prev, pager, next",
                      background: "",
                      "hide-on-single-page": false,
                      "current-page": _vm.studentListParams.currentPage,
                      "page-size": _vm.studentListParams.pageSize,
                      "page-sizes": [20, 50, 100],
                      total: _vm.tableDataTotal
                    },
                    on: {
                      "current-change": _vm.currentPageChange,
                      "size-change": _vm.monitorSizeChange
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "m-user-and-verify__right flex-column" }, [
              _vm.notice
                ? _c("div", { staticClass: "sign-tips-wrapper" }, [
                    _c(
                      "div",
                      { ref: "notice-box", staticClass: "notice-box" },
                      [
                        _c(
                          "div",
                          {
                            ref: "notice-bar",
                            staticClass: "white-nowrap flex-row",
                            class: { "notice-bar": _vm.isMove }
                          },
                          [
                            _c("img", {
                              staticClass: "m-tips__info-img",
                              attrs: {
                                src: require("../../assets/img/img_info.png")
                              }
                            }),
                            _vm._v("温馨提示: " + _vm._s(_vm.notice) + " ")
                          ]
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _c("div", { staticClass: "m-sign__verify" }, [
                _c("div", { staticClass: "m-verify__top-row flex-row" }, [
                  _c("div", { staticClass: "m-top__left" }, [
                    _vm._v(
                      "电脑验证区（" + _vm._s(_vm.signType.signTypeName) + "）"
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "m-top__right-operation-btn flex-row" },
                    [
                      _vm.signCtrlParam.faceLiveDetectionPc == 1 &&
                      !_vm.isOfflineMeeting &&
                      _vm.signCtrlParam.isFaceVerify
                        ? _c(
                            "div",
                            {
                              staticClass: "m-btn-item flex-row",
                              class:
                                "m-btn-item" +
                                (_vm.signInType.pcSignIn == 0
                                  ? "-active"
                                  : " "),
                              on: {
                                click: function($event) {
                                  return _vm.handleSignInType("pc")
                                }
                              }
                            },
                            [
                              _vm.signInType.pcSignIn == 0
                                ? _c("img", {
                                    staticClass: "m-btn__img",
                                    attrs: {
                                      src: require("../../assets/img/img_pc.png")
                                    }
                                  })
                                : _c("img", {
                                    staticClass: "m-btn__img",
                                    attrs: {
                                      src: require("../../assets/img/img_pc_gray.png")
                                    }
                                  }),
                              _vm._v(
                                " " + _vm._s(_vm.signInType.pcSignInName) + " "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.signCtrlParam.faceLiveDetectionApp == 1 &&
                      _vm.signCtrlParam.isFaceVerify
                        ? _c(
                            "div",
                            {
                              staticClass: "m-btn-item flex-row",
                              class:
                                "m-btn-item" +
                                (_vm.signInType.phoneSignIn == 0
                                  ? "-active"
                                  : " "),
                              on: {
                                click: function($event) {
                                  return _vm.handleSignInType("phone")
                                }
                              }
                            },
                            [
                              _vm.signInType.phoneSignIn == 0
                                ? _c("img", {
                                    staticClass: "m-btn__img",
                                    attrs: {
                                      src: require("../../assets/img/img_phone.png")
                                    }
                                  })
                                : _c("img", {
                                    staticClass: "m-btn__img",
                                    attrs: {
                                      src: require("../../assets/img/img_phone_gray.png")
                                    }
                                  }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.signInType.phoneSignInName) +
                                  " "
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "m-btn-item flex-row" },
                        [
                          _c("img", {
                            staticClass: "m-btn__img",
                            attrs: {
                              src: require("../../assets/img/img_edit.png")
                            }
                          }),
                          _c(
                            "el-link",
                            {
                              staticClass: "update-user-face",
                              attrs: { type: "info", underline: false },
                              on: { click: _vm.updateUserFace }
                            },
                            [_vm._v("修改注册照 ")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]),
                _vm.showPcVerifyView
                  ? _c(
                      "div",
                      { staticClass: "m-verify__user-info flex-column" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "m-user-info flex-column",
                            attrs: { id: _vm.operationGuideListId[2] }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "m-user__photo-row flex-row" },
                              [
                                _c("div", { staticClass: "m-photo__item" }, [
                                  _c("img", {
                                    staticClass: "m-item__img",
                                    attrs: {
                                      src:
                                        _vm.signUserInfo.srcUserInfo.faceUrl ||
                                        _vm.signUserInfo.defaultHead,
                                      alt: ""
                                    }
                                  }),
                                  _c("div", { staticClass: "m-item__label" }, [
                                    _vm._v("注册照")
                                  ])
                                ]),
                                _vm._m(0)
                              ]
                            ),
                            _vm.signUserInfo.srcUserInfo
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex-row m-verity__user-info-text"
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "m-user__img",
                                      attrs: {
                                        src: require("../../assets/img/img_notice.png")
                                      }
                                    }),
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.signUserInfo.srcUserInfo.realName
                                        )
                                      )
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "verify-identity-text" },
                                      [
                                        _vm._v(
                                          "（" +
                                            _vm._s(
                                              _vm.signUserInfo.srcUserInfo
                                                .identityName || "学员"
                                            ) +
                                            "）"
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "verify-state-text",
                                        attrs: {
                                          title: _vm.signUserInfo.signInStatus
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.signUserInfo.signInStatus
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm.signUserInfo.srcUserInfo
                              ? _c(
                                  "div",
                                  { staticClass: "flex-column" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "m-btn__camera_verity",
                                        attrs: {
                                          type: "primary",
                                          size: "medium",
                                          loading: _vm.takePhotoLoading
                                        },
                                        on: { click: _vm.takeSignInPhoto }
                                      },
                                      [_vm._v("拍照验证 ")]
                                    )
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  { staticClass: "m-empty-sign-user__tip" },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.getPcVerityTipText) + " "
                                    )
                                  ]
                                )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "m-verity-photo-tips flex-column" },
                          [
                            _c(
                              "div",
                              { staticClass: "m-tip__img-text flex-row" },
                              _vm._l(_vm.imgTipList, function(item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "m-item flex-column"
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "m-tip__img",
                                      attrs: { src: item.img }
                                    }),
                                    _c("div", { staticClass: "m-tip__text" }, [
                                      _vm._v(_vm._s(item.label))
                                    ])
                                  ]
                                )
                              }),
                              0
                            ),
                            _c("div", { staticClass: "m-tip__text" }, [
                              _c("li", [
                                _c("span", {
                                  staticClass: "m-text-list-style"
                                }),
                                _vm._v(
                                  "请点击“" +
                                    _vm._s(_vm.signType.signTypeName) +
                                    "”，核对注册照是否为本人，并且照片清晰合规； "
                                )
                              ]),
                              _c("li", [
                                _c("span", {
                                  staticClass: "m-text-list-style"
                                }),
                                _vm._v(
                                  "核对注册照无误后，请正对摄像头，按照“正确示例图”将人脸放入摄像框内，保持不动 点击“拍照验证”，等待" +
                                    _vm._s(_vm.signType.signTypeName) +
                                    "验证！ "
                                )
                              ])
                            ])
                          ]
                        )
                      ]
                    )
                  : _c("div", { staticClass: "m-verify__empty flex-column" }, [
                      _c("img", {
                        staticClass: "m-empty__img",
                        attrs: {
                          src: require("../../assets/img/no_verity_user.png")
                        }
                      }),
                      _c("div", { staticClass: "c-empty__text flex-column" }, [
                        _vm._v(_vm._s(_vm.getEmptyVerityText))
                      ])
                    ])
              ])
            ])
          ])
        ]),
        _c("canvas", {
          staticStyle: { display: "none" },
          attrs: { id: "qr-code-image-box" }
        })
      ]),
      _c("TakePhotoDialog", {
        ref: "takePhotoDialog",
        on: {
          "call-back": _vm.hanldeTakePhotoCallBackEvent,
          closeDialogCamera: _vm.closeDialogCamera
        }
      }),
      _c("LoginOutDialog", {
        attrs: {
          propDialogVisible: _vm.logOutDialog.visible,
          propDialogObject: _vm.logOutDialog
        },
        on: {
          "update:propDialogVisible": function($event) {
            return _vm.$set(_vm.logOutDialog, "visible", $event)
          },
          "update:prop-dialog-visible": function($event) {
            return _vm.$set(_vm.logOutDialog, "visible", $event)
          }
        }
      }),
      _c("LoginForceOutDialog", {
        attrs: {
          propDialogVisible: _vm.loginForceOutDialog.visible,
          propDialogObject: _vm.loginForceOutDialog
        },
        on: {
          "update:propDialogVisible": function($event) {
            return _vm.$set(_vm.loginForceOutDialog, "visible", $event)
          },
          "update:prop-dialog-visible": function($event) {
            return _vm.$set(_vm.loginForceOutDialog, "visible", $event)
          },
          "cancel-back": _vm.clearSignStatus,
          "call-back": _vm.callForceOutSureDialogBack
        }
      }),
      _c("updateClassroomAddressDialog", {
        attrs: {
          visible: _vm.updateClassroomAddressDialog.visible,
          dialogObject: _vm.updateClassroomAddressDialog.obj,
          signTypeName: _vm.signType.signTypeName
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.updateClassroomAddressDialog, "visible", $event)
          },
          openScan: _vm.phoneSignInOpen,
          callback: _vm.checkSafeManagerAddress
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "m-photo__item m-item__camera" }, [
      _c("div", { attrs: { id: "signInUserBox" } }),
      _c("div", { staticClass: "m-item__label" }, [_vm._v("摄像框")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }